// extracted by mini-css-extract-plugin
export var imgLogo = "LogoLink-module--imgLogo--2f0ae";